/**
 * Cache-key prefix the subscriptions list page registers its ListQueryService
 * entries under. The store's mutation effects invalidate this prefix so the
 * list refreshes after a create/update/cancel/discount, while embedded cursor
 * lists (which read the NgRx collection) are untouched.
 */
export const SUBSCRIPTION_LIST_QUERY_PREFIX = 'subscription|list|';
